import { Context } from 'Context/Context';
import useIsMobile from 'Hooks/useIsMobile';
import { Crown } from 'lucide-react';
import React, { useContext } from 'react'
import { Link } from 'react-router-dom'

function MembershipButton() {
    const {userDetails} = useContext(Context);
    const isMobile = useIsMobile();

  return (
            <Link to="/attorney/subscription">
                {
                    isMobile ? 
                    <div className="pl-2 text-left text-tan text-sm lg:mt-2 cursor-pointer ">
                        {!userDetails.isActiveSubscription ?
                            <div className="flex rounded p-1 py-1">
                            <Crown className='w-4 h-4 mr-2 '/>
                            Upgrade to Premium
                            </div>
                            :
                            <div className="flex rounded p-1 py-1">
                            <Crown className='w-4 h-4 mr-2 '/>
                            Premium membership
                            </div>
                        }
                    </div>
                    :
                    (!userDetails.isActiveSubscription ?
                        <span className="inline-flex items-center whitespace-nowrap transition-colors hover:bg-[rgba(201,162,106,0.12)]" style={{gap:'7px', padding:'10px 15px', borderRadius:'5px', border:'1px solid rgba(201,162,106,.6)', font:"600 13px/1 'IBM Plex Sans',sans-serif", color:'#c9a26a'}}>
                            <Crown size={14} fill="#c9a26a" strokeWidth={0}/>
                            Upgrade to Premium
                        </span>
                        :
                        // Case List design: brass button with a crown
                        <span className="inline-flex items-center whitespace-nowrap transition-colors hover:!bg-[#6d4c25]" style={{gap:'7px', padding:'11px 16px', borderRadius:'5px', background:'#8a6231', font:"600 13px/1 'IBM Plex Sans',sans-serif", color:'#fffdf8'}}>
                            <Crown size={14} fill="#fffdf8" strokeWidth={0}/>
                            Premium membership
                        </span>
                    )
                    }
                    
            </Link>
  )
}

export default MembershipButton